import React, { useState } from "react";
import Section from "../components/Section";
import RecomendacionCard from "../components/RecomendacionCard";
import { recomendaciones } from "../data/recomendaciones";

const Recomendaciones = () => {
  const [paginaActual, setPaginaActual] = useState(1);
  const porPagina = 6;

  const totalPaginas = Math.ceil(recomendaciones.length / porPagina);

  const cambiarPagina = (nuevaPagina) => {
    setPaginaActual(nuevaPagina);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const eventosPagina = recomendaciones.slice(
    (paginaActual - 1) * porPagina,
    paginaActual * porPagina
  );
  return (
    <Section title="Recomendaciones">
      <div className="card-grid">
        {eventosPagina.map((recomendacion, i) => (
          <RecomendacionCard key={i} recomendacion={recomendacion} />
        ))}
      </div>

      <div className="pagination">
        <button
          disabled={paginaActual === 1}
          onClick={() => cambiarPagina(paginaActual - 1)}
        >
          Anterior
        </button>

        {Array.from({ length: totalPaginas }, (_, i) => (
          <button
            key={i + 1}
            className={paginaActual === i + 1 ? "active" : ""}
            onClick={() => cambiarPagina(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          disabled={paginaActual === totalPaginas}
          onClick={() => cambiarPagina(paginaActual + 1)}
        >
          Siguiente
        </button>
      </div>
    </Section>
  );
};

export default Recomendaciones;